export default "__VITE_ASSET__CQHrTFG2__"